"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenQuotationButton = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _MoreHoriz = _interopRequireDefault(require("@material-ui/icons/MoreHoriz"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HiddenQuotationButton = exports.HiddenQuotationButton = function HiddenQuotationButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var onMouseDown = function onMouseDown(event) {
    event.preventDefault();
    onClick();
    setVisible(false);
  };
  if (!visible) return null;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "inline-flex items-center overflow-hidden text-gray-medium bg-gray-divider rounded-full hover:shadow h-3 px-1 cursor-pointer my-2 leading-loose",
    onMouseDown: onMouseDown
  }, /*#__PURE__*/_react["default"].createElement(_MoreHoriz["default"], null));
};
//# sourceMappingURL=HiddenQuotationButton.js.map